import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: false,
    selector: 'app-order-limit-dialog',
    templateUrl: './order-limit-dialog.component.html',
    styleUrls: ['./order-limit-dialog.component.scss'],
})
export class OrderLimitDialogComponent {
    constructor(private ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

    closeDialog() {
        this.ref.close();
    }

    accept() {
        this.ref.close(true);
    }
}
